/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPublicServices200, GetApiPublicServicesQueryResponse } from "../entities/GetApiPublicServices";
import { modelsPublicServicesOutputSchema } from "./models/publicServicesOutputSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const getApiPublicServices200Schema = z.lazy(() => modelsPublicServicesOutputSchema) as unknown as z.ZodType<GetApiPublicServices200>

export const getApiPublicServicesQueryResponseSchema = z.lazy(() => getApiPublicServices200Schema) as unknown as z.ZodType<GetApiPublicServicesQueryResponse>